











import Vue from 'vue';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import store from '@/store';
import * as CvDesignStore from '@/containers/cv-design/store';
import EditContainer from '@/containers/cv-design/edit.vue';
const fetch = async params => {
  const { cv_id } = params;
  await Promise.all([
    store.dispatch(CvDesignStore.GetCv.namespaced({ cv_id })),
    store.dispatch(CvDesignStore.GetCvDesignTemplateSamples.namespaced(null)),
  ]);
};
export default Vue.extend({
  components: {
    EditContainer,
  },
  mixins: [PageLeftHook, PageFetchHook(fetch)],
  data() {
    return {
      storeList: [CvDesignStore],
    };
  },
});
